import {Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Icon, SkeletonText, Text} from '@chakra-ui/react';
import {ChevronRight} from 'lucide-react';
import {useRouter} from 'next/router';
import React from 'react';
import {colors} from 'theme';

export interface IBreadcrumb {
  label: string;
  href?: string;
  isCurrentPage?: boolean;
}

interface BreadcrumbsProps {
  items: IBreadcrumb[];
  isLoading?: boolean;
  onItemClick?: () => void;
  isInModal?: boolean;
}

const MetroBreadcrumb: React.FC<BreadcrumbsProps> = ({items, isLoading, onItemClick, isInModal}) => {
  const {push} = useRouter();
  return (
    <Box>
      {isLoading ? (
        <MetroBreadcrumbSkeleton />
      ) : (
        <Breadcrumb
          fontSize="14px"
          color="gray.600"
          separator={
            <Box alignItems="center" display="flex" justifyContent="center" height="24px">
              <Icon>
                <ChevronRight />
              </Icon>
            </Box>
          }
        >
          {items.map((item, idx) => (
            <BreadcrumbItem
              key={idx}
              isCurrentPage={item.isCurrentPage}
              fontWeight={600}
              fontSize="13px"
              maxW={isInModal ? '150px' : '210px'}
            >
              {item.isCurrentPage ? (
                <Text as="span" color={colors.textGray} fontWeight={600} fontSize="13px" isTruncated>
                  {item.label}
                </Text>
              ) : (
                <BreadcrumbLink
                  onClick={() => {
                    push(item.href || '#');
                    onItemClick?.();
                  }}
                  // href={item.href || '#'}
                  textDecoration="none"
                  _hover={{textDecoration: 'none'}}
                  color={colors.darkCharcoal}
                  isTruncated
                >
                  {item.label}
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>
          ))}
        </Breadcrumb>
      )}
    </Box>
  );
};

const MetroBreadcrumbSkeleton: React.FC = () => (
  <Breadcrumb fontSize="14px" color="gray.600">
    {[...Array(3)].map((_, idx) => (
      <BreadcrumbItem key={idx}>
        <SkeletonText noOfLines={1} width="100px" skeletonHeight="26px" borderRadius="md" overflow="hidden" />
      </BreadcrumbItem>
    ))}
  </Breadcrumb>
);
export default MetroBreadcrumb;
